import React from 'react';
import './AboutUs.css';

import { PageTitle, Counter } from '../../../components';
import { About, Clients, Gallery, Menu, Services } from '../../../sections';



const AboutUs = () => { 
  return (
    <>
      <PageTitle title={'about us'} page={'about'} />
      <section className='about-us'>
        <About />
        <Menu />
        <Services />
        {/* <Counter /> */}
        <Gallery />
        <Clients />
      </section> 
    </>
  )
}

export default AboutUs;